import React from "react";
import { NavLink, Outlet, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "../i18n";

const sections = [
  ["", "overview", "ri-dashboard-line"],
  ["copilot", "copilot", "ri-robot-2-line"],
  ["playbook", "playbook", "ri-magic-line"],
  ["knowledge", "knowledge", "ri-book-open-line"],
  ["abilities", "abilities", "ri-flashlight-line"],
  ["test", "test", "ri-test-tube-line"],
  ["appearance", "appearance", "ri-palette-line"],
  ["analytics", "analytics", "ri-line-chart-line"],
  ["settings", "settings", "ri-settings-3-line"],
] as const;

const SiteWorkspaceLayout: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { siteId = "" } = useParams<{ siteId: string }>();
  const base = `/sites/${encodeURIComponent(siteId)}`;
  return (
    <div className="site-workspace-shell">
      <header className="site-workspace-shell__bar">
        <button onClick={() => navigate("/sites")}><i className="ri-arrow-left-line" />{t("siteWorkspace.back")}</button>
        <nav aria-label={t("siteWorkspace.aria")}>
          {sections.map(([path, key, icon]) => (
            <NavLink key={path} to={path ? `${base}/${path}` : base} end={!path}>
              <i className={icon} />{t(`siteWorkspace.${key}`)}
            </NavLink>
          ))}
        </nav>
      </header>
      <Outlet />
    </div>
  );
};

export default SiteWorkspaceLayout;
